import React from 'react';
import useStyles from '@front10/helpers/dist/UseStyles';
import Col from '../../../elements/Col';
import Row from '../../../elements/Row';
import Box from '../../../elements/Box';

const styles = {
  box: {
    height: '155px',
    width: '155px',
    background: '#B7C3D3'
  },
  side: {
    background: '#F8F8F8',
    width: 'calc(100% - 155px)',
    gap: {
      padding: '15px'
    }
  },
  line: {
    background: 'linear-gradient(90deg, #F3F4F6 0%, #E5E7EB 100%)',
    height: '24px',
    marginRight: '5px',
    display: 'inline-block',
    clear: {
      clear: 'both'
    },
    newLine: {
      display: 'block'
    }
  },
  line2: {
    height: '21px'
  },
  line3: {
    height: '18px',
    marginBottom: '2px'
  },
  line4: {
    height: '36px'
  }
};

const SkeletonFlightRecommender = (props) => {
  const [className, style] = useStyles(props);
  const {
    itemsToShow = 3,
    imageSettings = { 'cmp-styles': { 'border-radius': '5px 0px 0px 5px' } },
    contentSettings = { 'cmp-styles': { 'border-radius': '0px 5px 5px 0px' } }
  } = props;
  const { box, side, line, line2, line3, line4 } = styles;
  return (
    <Box className={className} style={style} dataTestId="SkeletonFlightRecommender">
      {Array(itemsToShow)
        .fill('')
        .map((i, index) => {
          return (
            <Row cmp-styles={{ 'margin-bottom': '10px' }} key={index}>
              <Col xs={15} style={box} {...imageSettings}></Col>
              <Col style={{ ...side, ...side.gap }} {...contentSettings}>
                <Row>
                  <Col xs={10} md={10}>
                    <Box style={{ ...line, width: '170px' }}></Box>
                    <Box style={{ ...line, ...line.clear, width: '61px' }}></Box>
                    <Box
                      style={{ ...line, ...line.newLine, width: '124px', marginBottom: '27px' }}
                    ></Box>
                    <Row>
                      <Col xs={12} style={{ ...line2, marginBottom: '3px' }}>
                        <Box
                          style={{ ...line, ...line2, width: '61px', marginRight: '52px' }}
                        ></Box>
                        <Box style={{ ...line, ...line2, ...line.clear, width: '61px' }}></Box>
                      </Col>
                      <Col xs={12} style={{ ...line2 }}>
                        <Box
                          style={{ ...line, ...line2, width: '80px', marginRight: '52px' }}
                        ></Box>
                        <Box style={{ ...line, ...line2, ...line.clear, width: '80px' }}></Box>
                      </Col>
                    </Row>
                  </Col>
                  <Col xs={1} style={{ alignSelf: 'end' }}>
                    <Box style={{ ...line, ...line3, ...line.newLine, width: '36px' }}></Box>
                    <Box style={{ ...line, ...line3, ...line.newLine, width: '48px' }}></Box>
                    <Box style={{ ...line, ...line4, ...line.newLine, width: '57px' }}></Box>
                  </Col>
                </Row>
              </Col>
            </Row>
          );
        })}
    </Box>
  );
};

SkeletonFlightRecommender.componentName = 'SkeletonFlightRecommender';

export default SkeletonFlightRecommender;
